import { useSkillsQuery } from '@/modules/skills/graphql/queries/generated/skills';
import { GeneratedByEnum, Maybe, SkillTypeEnum } from '@/types/schema';

interface Params {
  ids?: Maybe<string[]>;
  filteredSkillIds?: string[];
  searchText?: Maybe<string>;
  isMindset?: boolean;
  pause?: boolean;
  isSkillOrMindset?: boolean;
}

const useSkills = ({
  ids = [],
  pause,
  searchText = '',
  filteredSkillIds = [],
  isMindset,
  isSkillOrMindset,
}: Params) => {
  const types = isSkillOrMindset
    ? [SkillTypeEnum.Ability, SkillTypeEnum.Behavior]
    : isMindset
    ? [SkillTypeEnum.Behavior]
    : [SkillTypeEnum.Ability];
  const [{ data, fetching, error }] = useSkillsQuery({
    variables: {
      filters: {
        ids,
        name: searchText,
        generatedBy: GeneratedByEnum.All,
        visibleInListing: true,
        types,
        includeMicroSkills: !isMindset && !!ids?.length,
      },
    },
    pause,
  });

  const skills =
    data?.skills.edges
      ?.map(({ node }) => node)
      .filter((node) => !filteredSkillIds.includes(node.id)) || [];

  return { skills, fetching, error };
};

export default useSkills;
